"use client"

import { useEffect } from "react"
import { browserAgent } from "@/lib/browser-agent"

interface PostHogSyncProps {
    userId?: string
}

export function PostHogSync({ userId }: PostHogSyncProps) {
    useEffect(() => {
        if (userId) {
            browserAgent.identify(userId)
        } else {
            browserAgent.reset()
        }
    }, [userId])

    return null
}
